import { Component, input } from "@angular/core";
import { RvbSummary } from "../../models/rent-vs-buy.models";
import { RvbFormatPipe } from "../../pipes/rvb-format.pipe";
import { IconComponent } from "../../../../../components/icon/icon.component";

@Component({
    selector: "hs-rvb-winner-banner",
    standalone: true,
    imports: [RvbFormatPipe, IconComponent],
    template: `
        <div class="winner-banner">
            <div class="winner-banner__left">
                <!--                <div>-->
                <!--                    {{ summary().winner === "buy" ? "🏠" : "🔑" }}-->
                <!--                </div>-->

                @if (summary().winner === "buy") {
                    <hs-icon
                        class="winner-banner__icon"
                        [src]="'/icons/home-gray.svg'"
                        [width]="32"
                        [height]="32"
                    ></hs-icon>
                } @else {
                    <hs-icon
                        class="winner-banner__icon"
                        [src]="'/icons/key.svg'"
                        [width]="32"
                        [height]="32"
                    ></hs-icon>
                }

                <div>
                    <div class="winner-banner__verdict">
                        {{ summary().winner === "buy" ? "Buying" : "Renting" }}
                        is ahead by
                        {{ summary().advantage | rvbFormat: "compact" }}
                    </div>
                    <div class="winner-banner__sub">
                        over your {{ horizon() }}-year horizon
                    </div>
                </div>
            </div>
            <div class="winner-banner__stats">
                <div class="winner-banner__stat">
                    <div class="winner-banner__stat-val">
                        {{ summary().finalBuyNetCost | rvbFormat: "compact" }}
                    </div>
                    <div class="winner-banner__stat-lbl">Buy net cost</div>
                </div>
                <div class="winner-banner__stat">
                    <div class="winner-banner__stat-val">
                        {{ summary().finalRentNetCost | rvbFormat: "compact" }}
                    </div>
                    <div class="winner-banner__stat-lbl">Rent net cost</div>
                </div>
                <div class="winner-banner__stat">
                    <div class="winner-banner__stat-val">
                        {{ summary().advantage | rvbFormat: "compact" }}
                    </div>
                    <div class="winner-banner__stat-lbl">Advantage</div>
                </div>
            </div>
        </div>
    `,
    styleUrl: "./rvb-winner-banner.component.scss",
})
export class RvbWinnerBannerComponent {
    readonly summary = input.required<RvbSummary>();
    readonly horizon = input.required<number>();
}
